import { DataBean } from "../DataBean";

export class CostAnalysis extends DataBean {


    public async deleteAirLine(idAirLine: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAirLine_Number", [idAirLine]);
    }



}